<div [ngClass]="['mp-snackbar', type ?? '', panelClass ?? '']" [@snackbarAnimation]>
  <div *ngIf="message">{{ message }}</div>
  <button *ngIf="message" class="mp-snackbar-button" (click)="mpSnackbarRef.dismiss()">
    {{ 'GLOBAL.OK' | translate }}
  </button>

  <ng-container *ngIf="innerComponent"
    [ngComponentOutlet]="innerComponent">
  </ng-container>
</div>
